'use client'

import { Icon } from '@components/primitives/Icon'
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft'
import { useRouter } from 'next/navigation'

export const BackNavigationCaret = () => {
  const router = useRouter()

  return (
    <Icon
      className='-ml-5 cursor-pointer p-5'
      icon={faChevronLeft}
      onClick={() => router.back()}
    />
  )
}
